import { defineMessages } from 'react-intl';

export default defineMessages({
  labelNotFound: {
    description: 'Automation Rules - label not found',
    defaultMessage: 'Label not found',
    id: '0xbwzT',
  },
  addTagLabel: {
    description: 'Automation Rules - Add Tag - label',
    defaultMessage: 'Add Tag',
    id: 'I23+4Y',
  },
  addTaxIdentifiersLabel: {
    description: 'Automation Rules - Add Tax Identifiers - label',
    defaultMessage: 'Add Tax Identifiers',
    id: 'MAVXuP',
  },
  createAlertLabel: {
    description: 'Automation Rules - Create Alert - label',
    defaultMessage: 'Alert',
    id: 'we8Ag/',
  },
  declarationStatementLabel: {
    description: 'Automation Rules - Declaration Statement - label',
    defaultMessage: 'Declaration Statement',
    id: '9LeMtq',
  },
  dimensionsLabel: {
    description: 'Automation Rules - Dimensions - label',
    defaultMessage: 'Dimensions',
    id: 'alDZPY',
  },
  assignUserLabel: {
    description: 'Automation Rules - Assign User - label',
    defaultMessage: 'Assign User',
    id: 'uv249a',
  },
  setShipFromLabel: {
    description: 'Automation Rules - Assign User - label',
    defaultMessage: 'Ship From Location',
    id: 'ettKSX',
  },
  useShipmentNotificationLabel: {
    description: 'Automation Rules - Use Shipment Notification Template - label',
    defaultMessage: 'Use Shipment Notification Template',
    id: 'SHNRG4',
  },
  usePackingSlipLabel: {
    description: 'Automation Rules - Use Packing Slip Template - label',
    defaultMessage: 'Use Packing Slip Template',
    id: 'DJBMy+',
  },
  useDeliveryNotificationLabel: {
    description: 'Automation Rules - Use Delivery Notification Template - label',
    defaultMessage: 'Use Delivery Notification Template',
    id: 'Pr/KIb',
  },
  holdOrderForLabel: {
    description: 'Automation Rules - Hold Order For - label',
    defaultMessage: 'Hold Order For',
    id: 'VpeyYG',
  },
  setShipByLabel: {
    description: 'Automation Rules - Set Ship By - label',
    defaultMessage: 'Set Ship By To',
    id: 'BxobIi',
  },
  setDeliverByLabel: {
    description: 'Automation Rules - Set Deliver By - label',
    defaultMessage: 'Set Deliver By To',
    id: 'Z0KA0p',
  },
  addInternalNoteLabel: {
    description: 'Automation Rules - Add Internal Note - label',
    defaultMessage: 'Add Internal Note',
    id: 'DyGSRW',
  },
  addNoteToBuyerLabel: {
    description: 'Automation Rules - Note to Buyer - label',
    defaultMessage: 'Note to Buyer',
    id: 'miuYoF',
  },
  setOrderTotalWeightLabel: {
    description: 'Automation Rules - Set Order Total Weight - label',
    defaultMessage: 'Set Order Total Weight',
    id: 'z2Ei+Z',
  },
  adjustOrderWeightLabel: {
    description: 'Automation Rules - Adjust Order Weight - label',
    defaultMessage: 'Adjust Order Weight',
    id: '4pDjC0',
  },
  customFieldOneLabel: {
    description: 'Automation Rules - Custom Field 1 - label',
    defaultMessage: 'Custom Field 1',
    id: '0gOb/6',
  },
  customFieldTwoLabel: {
    description: 'Automation Rules - Custom Field 2 - label',
    defaultMessage: 'Custom Field 2',
    id: 'OG/+KM',
  },
  customFieldThreeLabel: {
    description: 'Automation Rules - Custom Field 3 - label',
    defaultMessage: 'Custom Field 3',
    id: 'GE89ZW',
  },
  insurePackageLabel: {
    description: 'Automation Rules - Insure Package - label',
    defaultMessage: 'Insure Package',
    id: 'ZoMZgs',
  },
  requestConfirmationLabel: {
    description: 'Automation Rules - Request Confirmation - label',
    defaultMessage: 'Request Confirmation',
    id: 'VEd5jR',
  },
  setCustomsContentTypeLabel: {
    description: 'Automation Rules - Customs Content Type - label',
    defaultMessage: 'Customs Content Type',
    id: 'QiyPrl',
  },
  setInternationalNonDeliveryLabel: {
    description: 'Automation Rules - International Non Delivery - label',
    defaultMessage: 'International Non-Delivery',
    id: 'C6sb4t',
  },
  setDryIceWeightLabel: {
    description: 'Automation Rules - Dry Ice Weight - label',
    defaultMessage: 'Dry Ice Weight',
    id: 'ca7VPl',
  },
  sendEmailLabel: {
    description: 'Automation Rules - Send an Email - label',
    defaultMessage: 'Recipient Email Addresses (comma-separated list)',
    id: '6TVMNR',
  },
  holdUntilLabel: {
    description: 'Automation Rules - Hold Until - label',
    defaultMessage: 'Hold Until',
    id: 'SPpD6T',
  },
  chargeToMyAccountLabel: {
    description: 'Automation Rules - Charge Shipping to My Account - label',
    defaultMessage: 'Account',
    id: 'mV3WTn',
  },
  serviceLabel: {
    description:
      'Label to display on the input field when the user selects the "Delegate to Selected Fulfillment Provider" as the Action Type',
    defaultMessage: 'Service',
    id: 'aTnXQk',
  },
  setShipDateLabel: {
    description: 'Automation Rules - Set Ship Date - label',
    defaultMessage: 'Set Ship Date To',
    id: 'XIyheH',
  },
  addMovementIndicatorLabel: {
    description: 'Automation Rules - Add Movement Indicator - label',
    defaultMessage: 'Movement Indicator',
    id: 'fwdDZP',
  },
});
